module.exports = __webpack_public_path__ + "static/img/book.6e73e57.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/book.png
// module id = E045
// module chunks = 1